import React from 'react';
import { View } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from '@/components/NeolexonIcon/Icons/types';
import { IS_WEB } from '@/utils/platform';

export const Lugnut = ({
  color,
  fillColor,
  size = 24,
  style,
  ...props
}: IconProps) => {
  if (IS_WEB) {
    if (!fillColor || fillColor === 'none') {
      return (
        // unfilled
        <View {...props}>
          <svg
            width={size}
            height={size}
            viewBox="0 0 44 44"
            fill="none"
            style={style as React.CSSProperties}
          >
            <path
              d="M21.9966 7.91364C22.6165 7.55478 23.3809 7.55478 24.0008 7.91364L34.6674 14.0891C35.2851 14.4467 35.6654 15.1063 35.6654 15.8199V28.1804C35.6654 28.8941 35.2851 29.5537 34.6674 29.9112L24.0008 36.0867C23.3809 36.4455 22.6165 36.4455 21.9966 36.0867L11.33 29.9112C10.7123 29.5537 10.332 28.8941 10.332 28.1804V15.8199C10.332 15.1063 10.7123 14.4467 11.33 14.0891L21.9966 7.91364ZM24.0008 10.995C23.3809 10.6361 22.6165 10.6361 21.9966 10.995L13.9966 15.6264C13.379 15.984 12.9987 16.6436 12.9987 17.3573V26.643C12.9987 27.3567 13.379 28.0163 13.9966 28.3739L21.9966 33.0054C22.6165 33.3642 23.3809 33.3642 24.0008 33.0054L32.0008 28.3739C32.6184 28.0163 32.9987 27.3567 32.9987 26.643V17.3573C32.9987 16.6436 32.6184 15.984 32.0008 15.6264L24.0008 10.995ZM22.9987 27.3335C21.5842 27.3335 20.2277 26.7716 19.2275 25.7714C18.2273 24.7712 17.6654 23.4147 17.6654 22.0002C17.6654 20.5857 18.2273 19.2291 19.2275 18.2289C20.2277 17.2287 21.5842 16.6668 22.9987 16.6668C24.4132 16.6668 25.7697 17.2287 26.7699 18.2289C27.7701 19.2291 28.332 20.5857 28.332 22.0002C28.332 23.4147 27.7701 24.7712 26.7699 25.7714C25.7697 26.7716 24.4132 27.3335 22.9987 27.3335ZM22.9987 24.6668C23.7059 24.6668 24.3842 24.3859 24.8843 23.8858C25.3844 23.3857 25.6654 22.7074 25.6654 22.0002C25.6654 21.2929 25.3844 20.6146 24.8843 20.1145C24.3842 19.6144 23.7059 19.3335 22.9987 19.3335C22.2915 19.3335 21.6132 19.6144 21.1131 20.1145C20.613 20.6146 20.332 21.2929 20.332 22.0002C20.332 22.7074 20.613 23.3857 21.1131 23.8858C21.6132 24.3859 22.2915 24.6668 22.9987 24.6668Z"
              fill={color}
            />
          </svg>
        </View>
      );
    }

    return (
      // filled
      <View {...props}>
        <svg
          width={size}
          height={size}
          viewBox="0 0 44 44"
          fill="none"
          style={style as React.CSSProperties}
        >
          <path
            d="M21.9996 7.35156L34.6496 14.6752V29.3226L21.9996 36.6463L9.34961 29.3226V14.6752L21.9996 7.35156ZM21.9996 25.9937C23.0591 25.9937 24.0752 25.5728 24.8243 24.8236C25.5735 24.0745 25.9943 23.0584 25.9943 21.9989C25.9943 20.9395 25.5735 19.9234 24.8243 19.1742C24.0752 18.4251 23.0591 18.0042 21.9996 18.0042C20.9401 18.0042 19.9241 18.4251 19.1749 19.1742C18.4257 19.9234 18.0049 20.9395 18.0049 21.9989C18.0049 23.0584 18.4257 24.0745 19.1749 24.8236C19.9241 25.5728 20.9401 25.9937 21.9996 25.9937Z"
            fill={color}
          />
        </svg>
      </View>
    );
  }

  if (!fillColor || fillColor === 'none') {
    return (
      // unfilled
      <Svg
        width={size}
        height={size}
        viewBox="0 0 44 44"
        fill="none"
        style={style}
        {...props}
      >
        <Path
          d="M21.9966 7.91364C22.6165 7.55478 23.3809 7.55478 24.0008 7.91364L34.6674 14.0891C35.2851 14.4467 35.6654 15.1063 35.6654 15.8199V28.1804C35.6654 28.8941 35.2851 29.5537 34.6674 29.9112L24.0008 36.0867C23.3809 36.4455 22.6165 36.4455 21.9966 36.0867L11.33 29.9112C10.7123 29.5537 10.332 28.8941 10.332 28.1804V15.8199C10.332 15.1063 10.7123 14.4467 11.33 14.0891L21.9966 7.91364ZM24.0008 10.995C23.3809 10.6361 22.6165 10.6361 21.9966 10.995L13.9966 15.6264C13.379 15.984 12.9987 16.6436 12.9987 17.3573V26.643C12.9987 27.3567 13.379 28.0163 13.9966 28.3739L21.9966 33.0054C22.6165 33.3642 23.3809 33.3642 24.0008 33.0054L32.0008 28.3739C32.6184 28.0163 32.9987 27.3567 32.9987 26.643V17.3573C32.9987 16.6436 32.6184 15.984 32.0008 15.6264L24.0008 10.995ZM22.9987 27.3335C21.5842 27.3335 20.2277 26.7716 19.2275 25.7714C18.2273 24.7712 17.6654 23.4147 17.6654 22.0002C17.6654 20.5857 18.2273 19.2291 19.2275 18.2289C20.2277 17.2287 21.5842 16.6668 22.9987 16.6668C24.4132 16.6668 25.7697 17.2287 26.7699 18.2289C27.7701 19.2291 28.332 20.5857 28.332 22.0002C28.332 23.4147 27.7701 24.7712 26.7699 25.7714C25.7697 26.7716 24.4132 27.3335 22.9987 27.3335ZM22.9987 24.6668C23.7059 24.6668 24.3842 24.3859 24.8843 23.8858C25.3844 23.3857 25.6654 22.7074 25.6654 22.0002C25.6654 21.2929 25.3844 20.6146 24.8843 20.1145C24.3842 19.6144 23.7059 19.3335 22.9987 19.3335C22.2915 19.3335 21.6132 19.6144 21.1131 20.1145C20.613 20.6146 20.332 21.2929 20.332 22.0002C20.332 22.7074 20.613 23.3857 21.1131 23.8858C21.6132 24.3859 22.2915 24.6668 22.9987 24.6668Z"
          fill={color}
        />
      </Svg>
    );
  }

  return (
    // filled
    <Svg
      width={size}
      height={size}
      viewBox="0 0 44 44"
      fill="none"
      style={style}
      {...props}
    >
      <Path
        d="M21.9996 7.35156L34.6496 14.6752V29.3226L21.9996 36.6463L9.34961 29.3226V14.6752L21.9996 7.35156ZM21.9996 25.9937C23.0591 25.9937 24.0752 25.5728 24.8243 24.8236C25.5735 24.0745 25.9943 23.0584 25.9943 21.9989C25.9943 20.9395 25.5735 19.9234 24.8243 19.1742C24.0752 18.4251 23.0591 18.0042 21.9996 18.0042C20.9401 18.0042 19.9241 18.4251 19.1749 19.1742C18.4257 19.9234 18.0049 20.9395 18.0049 21.9989C18.0049 23.0584 18.4257 24.0745 19.1749 24.8236C19.9241 25.5728 20.9401 25.9937 21.9996 25.9937Z"
        fill={color}
      />
    </Svg>
  );
};
